<brd-usecases-grid [selectedRowKey]="selectedUseCases" (selectionChanged)="selectionChanged($event)" [customItems]="customToolbarItems">
</brd-usecases-grid>
